export function isHookAvailable() {
  var _window$__icloud__;

  var store = (_window$__icloud__ = window.__icloud__) === null || _window$__icloud__ === void 0 ? void 0 : _window$__icloud__.store;
  return !!store && window.__POWERED_BY_QIANKUN__;
}
export function setThemeDataAttr(themDataAttr) {
  var html = document.body.parentElement;
  html && (html.dataset['lsqmTheme'] = themDataAttr !== null && themDataAttr !== void 0 ? themDataAttr : 'current');
}
//# sourceMappingURL=es/loadOSUICssVars/utils.js.map